import React, { useEffect, useRef } from 'react';

import { useIntl } from 'react-intl';

import SignatureIcon from '@atlaskit/icon-lab/core/signature';
import { fg } from '@atlaskit/platform-feature-flags';

import SharedSalesforceDynamicMultiSelect from '../../../../../common/ui/filters/product-filters/shared-salesforce-dynamic-multi-select';
import type { FilterProps } from '../../../../../common/ui/filters/product-filters/types';
import { useSelectFilter } from '../../../../../controllers/filters/base-select-filter';
import { useFiltersDiscoverability2Enabled } from '../../../../../controllers/store/bootstrap';
import { filter as salesforceStageFilter } from '../../../../../controllers/store/search/filters/salesforce-stage';

import { i18n } from './messages';

const SalesforceStageFilter = (props: FilterProps): React.JSX.Element | null => {
	const { formatMessage } = useIntl();
	const isFiltersDiscoverability2Enabled = useFiltersDiscoverability2Enabled();
	const [filterData, { loadInitialOptions, setOption, clearOptions }] = useSelectFilter({
		filterId: salesforceStageFilter.id,
	});
	const shouldEagerLoadOptions = fg('rovo-fps-3p-ux-salesforce-dynamic-stage-filter');
	const hasLoadedInitialOptions = useRef(false);

	useEffect(() => {
		if (!hasLoadedInitialOptions.current && shouldEagerLoadOptions) {
			hasLoadedInitialOptions.current = true;
			loadInitialOptions();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [shouldEagerLoadOptions]);

	if (!filterData || !shouldEagerLoadOptions) {
		return null;
	}

	const { isLoading, suggestedOptions, selectedOptions } = filterData;

	return (
		<SharedSalesforceDynamicMultiSelect
			{...props}
			filterId={salesforceStageFilter.id}
			label={formatMessage(i18n.salesforceStageFilterLabel)}
			noOptionsMessage={formatMessage(i18n.salesforceStageFilterNoOptions)}
			iconBefore={<SignatureIcon label="" />}
			isLoading={isLoading}
			selectedOptions={selectedOptions}
			suggestedOptions={suggestedOptions}
			isFiltersDiscoverability2Enabled={isFiltersDiscoverability2Enabled}
			loadInitialOptions={loadInitialOptions}
			setOption={(option) => setOption(option)}
			clearOptions={clearOptions}
		/>
	);
};

export default SalesforceStageFilter;
